export default __webpack_public_path__ + "static/media/show-necklace-1.14f81e31.webp";